import React, { useRef, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Avatar,
  Typography,
} from "@mui/material";
import heroVideo from "../assets/hero.mp4";
import jea from "../assets/video.mp4";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import Footer from "../components/Footer";
// import Aboutus from "../cards/AboutCard";
import AboutCard from "../cards/AboutCard";
import Features from "../cards/Features";
import OurProcess from "../cards/OurProcess";
import Seamless from "../cards/Seamless";
import Testimonials from "../cards/testimonials";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const videoRef1 = useRef(null);
  const navigate = useNavigate()
  // const videoRef2 = useRef(null);
  const features = [
    {
      img: "https://www.essajeesatelier.com/wp-content/uploads/2023/05/Simple-Splendour-grid-home.jpg",
      city: "MUMBAI, MAHARASHTRA",
      title: "Sense and Simplicity",
    },
    {
      img: "https://www.essajeesatelier.com/wp-content/uploads/2023/05/Contemporary-Cool-grid-home.jpg",
      city: "KOLKATA, WEST BENGAL",
      title: "Chef's Kiss",
    },
    {
      img: "https://www.essajeesatelier.com/wp-content/uploads/2023/05/The-White-House-grid-home.jpg",
      city: "MUMBAI, MAHARASHTRA",
      title: "The White House",
    },
    {
      img: "https://www.essajeesatelier.com/wp-content/uploads/2023/05/Simple-Splendour-grid-home.jpg",
      city: "MUMBAI, MAHARASHTRA",
      title: "Sense and Simplicity",
    },
    {
      img: "https://www.essajeesatelier.com/wp-content/uploads/2023/05/Contemporary-Cool-grid-home.jpg",
      city: "KOLKATA, WEST BENGAL",
      title: "Chef's Kiss",
    },
    {
      img: "https://www.essajeesatelier.com/wp-content/uploads/2023/05/The-White-House-grid-home.jpg",
      city: "MUMBAI, MAHARASHTRA",
      title: "The White House",
    },
  ];
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) video.play().catch(() => {});
          else video.pause();
        });
      },
      { threshold: 0.5 }
    );

    if (videoRef1.current) observer.observe(videoRef1.current);
    // if (videoRef2.current) observer.observe(videoRef2.current);

    return () => {
      if (videoRef1.current) observer.unobserve(videoRef1.current);
      // if (videoRef2.current) observer.unobserve(videoRef2.current);
    };
  }, []);

  return (
    <Box sx={{ width: "100%", overflowX: "hidden", m: 0, p: 0 }}>
      {/* HERO SECTION */}
      <Box
        sx={{
          // display: "flex",
          // flexDirection: { xs: "column", md: "row" },
          height: { xs: "80vh", md: "100vh" },
          width: "100%",
          p: { xs: 2, md: 4 },
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ width: { xs: "100%", md: "100%" }, height: "100%" }}>
          <video
            ref={videoRef1}
            src={heroVideo}
            muted
            loop
            playsInline
            preload="none"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
            }}
          />
        </Box>
        {/* <Box sx={{ width: { xs: "100%", md: "50%" }, height: "100%", display:{xs:"none", md:"flex"} }}>
          <video
            ref={videoRef2}
            src="https://www.pexels.com/download/video/5928085/"
            muted
            loop
            playsInline
            preload="none"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Box> */}
      </Box>

      {/* INTRODUCTION */}
      {/* <Box
        sx={{
          py: { xs: 6, md: 10 },
          textAlign: "center",
          color: "#b2925a",
          background: "#fff",
          px: 2,
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 400, lineHeight: 1.3 }}>
          Award winning global luxury design company,
          <br />
          crafting unique spaces since 2014
        </Typography>
      </Box> */}

      {/* FEATURED PROJECTS */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
          px: { xs: 3, md: 8 },
          py: { xs: 6, md: 10 },
          backgroundColor: "#fff",
          alignItems: { xs: "center", md: "flex-start" },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "#b2925a",
            fontFamily: "serif",
            flex: 1,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          Featured Projects
        </Typography>

        <Box sx={{ flex: 2 }}>
          <Typography variant="body1" sx={{ color: "#333", mb: 2, textAlign:"justify" }}>
            Beyond aesthetics, true luxury lies in the details of execution.
            This collection features our most complex challenges—ranging from
            bespoke furniture fabrication and heritage restoration to turnkey
            corporate fit-outs.
          </Typography>
          <Typography variant="body1" sx={{ color: "#333", textAlign:"justify" }}>
            These projects highlight ARC Studioz not just as designers, but as
            technical partners who engineer the "nervous systems" of a
            building—the MEP, IT, and structural elements—ensuring that every
            space works as flawlessly as it looks.
          </Typography>
        </Box>

        <Box sx={{ flexShrink: 0 }}>
          <Button
            variant="outlined"
            sx={{
              borderColor: "#b2925a",
              color: "#b2925a",
              borderWidth: "1.5px",
              px: 3,
              py: 1,
              "&:hover": { backgroundColor: "#b2925a", color: "#fff" },
            }}
            onClick={()=>navigate("/projects")}
          >
            SEE ALL PROJECTS
          </Button>
        </Box>
      </Box>

      <Features />
      
      <AboutCard />

      {/* <OurProcess /> */}
      <Seamless />
      {/* <Testimonials /> */}
    </Box>
  );
};

export default Home;
